import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AboutSectionSchema } from '../types/AboutSectionSchema';

const initialState: AboutSectionSchema = {
    
};

export const AboutSectionSlice = createSlice({
    name: 'AboutSection',
    initialState,
    reducers: {
        template: (state, action: PayloadAction<string>) => {
           
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(, (state) => {
    //             state.error = undefined;
    //             state.isLoading = true;
    //         })
    //         .addCase(, (state) => {
    //             state.isLoading = false;
    //         })
    //         .addCase(, (state, action) => {
    //             state.isLoading = false;
    //             state.error = action.payload;
    //         });
    // },
});

export const { actions: AboutSectionActions } = AboutSectionSlice;
export const { reducer: AboutSectionReducer } = AboutSectionSlice;